var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "drive"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 15,
    height: 15,
    transform: "translate(39 143)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_630",
    "data-name": "Mask Group 630",
    transform: "translate(-39 -143)",
    clipPath: "url(#drive)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_73_",
    "data-name": "svgexport-6 (73)",
    transform: "translate(39 143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11484",
    "data-name": "Path 11484",
    d: "M13.048,13.86l1.9-3.514a.445.445,0,0,0-.006-.429L9.856,1.128a.443.443,0,0,0-.38-.219H5.524a.441.441,0,0,0-.38.219h0L.058,9.916a.445.445,0,0,0-.006.429l1.9,3.514a.441.441,0,0,0,.387.231H12.66a.44.44,0,0,0,.387-.232ZM3.1,13.212l1.522-2.637h9.2L12.4,13.212ZM5.524,2.226,6.977,4.74,2.352,12.751.942,10.144Zm1.96,3.393L9.84,9.7H5.13ZM9.222,1.787,13.8,9.7H10.855L7.866,4.521h0L6.286,1.787Z",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.db11462fd0d4802daaef89d66c534739.svg";
export { ForwardRef as ReactComponent };